import PropTypes from 'prop-types';
import React from 'react';
import {AssignmentModel} from "../../../../models/assignments/AssignmentModel";
import {Badge, MetadataLabel} from "NstyleComponents";
import {linkStatus, processAssignmentLink} from "../../../../services/AssignmentLinkService";
import {useDispatch} from "react-redux";
import {transferToProduct} from "../../../../actions/nav/productTransferAction";


const AssignmentsRow = ({assignment}) => {

    const dispatch = useDispatch();

    const statusVariant = () => {
        switch (assignment.status) {
            case "Incomplete":
                return "transparent blue";
            case "Complete":
                return "blue";
            default:
                return "";
        }
    };

    const formatDate = (dateAsString) => !dateAsString ? "" : new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric'}).format(new Date(dateAsString));

    const linkToAssignment = (url, productName) => {
        switch(processAssignmentLink(url))
        {
            case linkStatus.absolute:
                window.location = url;
                break;
            case linkStatus.transfer:
                dispatch(transferToProduct(productName, url));
                break;
        }
    }

    return (
        <div className="assignments__row" onClick={() => linkToAssignment(assignment.url, assignment.productName)}>
            <div className="columns is-vcentered is-marginless is-paddingless">
                <div className="assignments__cell column is-4-widescreen is-4-touch is-inline-block assignments__cell--right-border">
                    <MetadataLabel>
                        {assignment.name}
                    </MetadataLabel>
                </div>
                <div className="assignments__cell column is-2-widescreen is-2-touch">
                        <img className="assignments__product-logo" src={assignment.productLogoUrl}/>
                </div>
                <div className="assignments__cell column is-2-widescreen is-2-touch">
                    <Badge variant={statusVariant()}>
                        {assignment.status}
                    </Badge>
                </div>
                <div className="assignments__cell column is-2-widescreen is-hidden-desktop-only is-hidden-touch">
                    <MetadataLabel>
                        {formatDate(assignment.startDate)}
                    </MetadataLabel>
                </div>
                <div className="assignments__cell column is-2-widescreen is-2-touch">
                    <MetadataLabel>
                        {formatDate(assignment.dueDate)}
                    </MetadataLabel>
                </div>
            </div>
        </div>
    );
};

AssignmentsRow.propTypes = {
    assignment: PropTypes.shape(AssignmentModel)
};

export default AssignmentsRow;
